import { render, staticRenderFns } from "./BaseTable.vue?vue&type=template&id=100b4768"
import script from "./BaseTable.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseTable.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports